export const categorypage = {
    category: "Catégorie",
    newcategory: "Nouvelle catégorie",
    editcategory: "Editer la catégorie",
    deletecategory: "Supprimer la catégorie",
    subcategory: "Sous-catégorie",
    surface: "Surface",
    datebegin: "Date de début",
    dateend: "Date de fin",
    heating: "Chauffage",
    cooling: "Refroidissement",
    coollog: "Logistique de froid",
    coolcom: "Froid commercial",
    consdoc: "Conservation de documents ou collections",
    indicatorname: "Nom de l'indicateur",
    indicatorvalue: "Valeur de l'indicateur",
    addindicator: "Ajouter un indicateur",
    deleteindicator: "Supprimer l'indicateur",
    editindicator: "Editer l'indicateur",
}

export const patrimoinepage = {
    idefaoperat: "Id efa Operat",
    maincategory: "Catégorie principale",
    maincategorymissing : "Au moins une catégorie doit être renseignée dans l'onglet 'Catégories'",
    weatherstation: "Station météo",
    heatedsurface: "Surface chauffée",
    cooledsurface: "Surface climatisée",
    prefill: "Préremplir avec les champs du patrimoine",
    evcount: "Nombre de bornes de recharges pour véhicules électriques",
}

export const comptepage = {
    apiinterface: "Interface avec l'API OPERAT",
    sirenstructure: "SIREN de la structure assujettie",
    userkey: "Clé utilisateur de la structure assujettie",
    waitfortestresult: "Merci de patienter jusqu'à l'obtention du résultat",
    resultsuccess: "Connexion établie avec succès.",
    resultconsumptions: " consommation(s) trouvée(s) sur l'année de référence.",
    resultfailed: "Connexion impossible.",
    adresseEfa: "adresseEfa",
    complementNomEfa: "complementNomEfa",
    denominationOccupantEfa: "denominationOccupantEfa",
    idOccupantEfa: "idOccupantEfa",
    refOperatEfa: "refOperatEfa",
    typeOccupantEfa: "typeOccupantEfa",
    testapibutton: "Tester l'API",
    getalldatabutton: "Récupérer toutes les consommations sur l'API",
    getalldataconfirmation: "Etes vous sur de vouloir récupérer toutes les consommations déclarées sur l'API? Cela effacera les données enregistrées précédemment.",
    getallyes: "Oui",
    getallno: "Annuler",
    getalltextprogress: "Récupération des consommations en cours.",
    getalltextdone: "Récupération des consommations terminée.",
    getalltotalefa: "EFA à récupérer.",
    getallsuccessefa: " succès.",
    getallerrorefa: " en erreur.",
    getallpartialefa: " récupération(s) partielle(s).",
}


export const declapage = {
    consocategory: "Catégorie de consommation",
    yearchoice: "Choix de l'année",
    intertiarybill: "Entité assujettie au décret tertiaire",
    consoindi: "Déclarer de la consommation individuelle",
    consorep: "Déclarer de la consommation répartie",
    consocom: "Déclarer de la consommation d'espaces communs",
    consoelec: "Déclarer de la consommation en électricité",
    consogaznatreseau: "Déclarer de la consommation en gaz naturel réseau",
    consogaznatliq: "Déclarer de la consommation en gaz naturel liquéfié",
    consogazprop: "Déclarer de la consommation en gaz propane",
    consogazbut: "Déclarer de la consommation en gaz butane",
    consofiouldom: "Déclarer de la consommation en fioul domestique",
    consocharbonagglo: "Déclarer de la consommation en charbon",
    consohouille: "Déclarer de la consommation en houille",
    consoboisplaqind: "Déclarer de la consommation en bois plaquettes d'industries",
    consoboisplaqfor: "Déclarer de la consommation en bois plaquettes forestières",
    consoboisgran: "Déclarer de la consommation en bois granulés ou briquettes",
    consoboisbuche: "Déclarer de la consommation bois bûches",
    consoreseauchal: "Déclarer de la consommation en réseau de chaleur",
    consoreseaufrois: "Déclarer de la consommation en réseau de froid",
    intertiarybill: "Entité assujettie au décret tertiaire",
    startdate: "Mois de début de la plage de 12 mois consécutif",
    dju: "DJU",
    electricityconsumption: " en électricité sans compter les IRVE, en kWh",
    gasconsumption: " en gaz naturel, en kWh",
    liquidgasconsumption: " en gaz liquéfié, en kg",
    propanem3consumption: " en gaz propane, en m3",
    propanekgconsumption: " en gaz propane, en kg",
    butanem3consumption: " en gaz butane, en m3",
    butanekgconsumption: " en gaz butane, en kg",
    fuelconsumption: " en fioul domestique, en litres",
    coalconsumption: " en charbon aggloméré et briquettes, en kg",
    houilleconsumption: " en houille, en kg",
    industrywoodconsumption: " en bois (plaquettes d'industries), en kg",
    forestwoodconsumption: " en bois (plaquettes forestières), en kg",
    granulewoodconsumption: " en bois (granulés ou briquettes), en kg",
    logwoodconsumption: " en bois (bùches), en stères",
    heatnetworkconsumption: " en réseau de chaleur, en kWh",
    coldnetworkconsumption: " en réseau de froid, en kWh",
    vehiElecConsoAvcIRVEKWh: "Consommation en électricité de l’EFA  pour installations de recharge des véhicules électriques (IRVE), en kWh",
    froidLogistHauteurRefroidie: "Hauteur refroidie pour la logistique de froid, en mètres (m)",
    declaredonOperat: "Consommations déclarées sur OPERAT",
    getdatabutton: "Récupérer la déclaration sur OPERAT",
    waitforgetresult: "Merci de patienter jusqu'à l'obtention du résultat",
    getdatasuccess : "Déclaration récupérée avec succès",
    getdataerror : "Impossible de récupérer les consommations",
    declareconsumtion: "Déclarer les consommations",
    declareconsumptiontitle: "Déclaration des consommations - ",
    buttonnextpage: "Page suivante",
    buttongetconsumptionfromavob: "Récupérer les consommations",
    nodataday: "Nombre de jour sans donnée : ",
    multipledataday: "Nombre de jour avec plusieurs données : ",
    metertotal: "Consommation du compteur : ",
    noavobdata : "Aucun compteur récupéré",
    send: "Envoyer",
    sendtitle : "Envoyer la déclaration",
    yes: "Oui",
    confirmsend: "Etes vous sur de vouloir envoyer la déclaration?",
    wariningsend: " Attention, certaines consommations n'ont pas été renseignées.",
    declarationsend: "Declaration envoyée",
}


export const declaconsobycategory = {
    indi : {
        electricityconsumption: "consoIndiHorsIRVEKWh",
        gasconsumption: "consoIndiGazNatReseauxKWh",
        liquidgasconsumption: "consoIndiGazNatLiquefieKg",
        propanem3consumption: "consoIndiGazPropaneM3",
        propanekgconsumption: "consoIndiGazPropaneKg",
        butanem3consumption: "consoIndiGazButaneM3",
        butanekgconsumption: "consoIndiGazButaneKg",
        fuelconsumption: "consoIndiFioulDomestiLitre",
        coalconsumption: "consoIndiCharbonAggloBriqKg",
        houilleconsumption: "consoIndiHouilleKg",
        industrywoodconsumption: "consoIndiBoisPlaqIndustrieKg",
        forestwoodconsumption: "consoIndiBoisPlaqForestKg",
        granulewoodconsumption: "consoIndiBoisGranBriqKg",
        logwoodconsumption: "consoIndiBoisBuchesStere",
        heatnetworkconsumption: "consoIndiReseauChaleurKWh",
        coldnetworkconsumption: "consoIndiReseauFroidKWh",
    },
    rep : {
        electricityconsumption: "consoRepHorsIRVEKWh",
        gasconsumption: "consoRepGazNatReseauxKWh",
        liquidgasconsumption: "consoRepGazNatLiquefieKg",
        propanem3consumption: "consoRepGazPropaneM3",
        propanekgconsumption: "consoRepGazPropaneKg",
        butanem3consumption: "consoRepGazButaneM3",
        butanekgconsumption: "consoRepGazButaneKg",
        fuelconsumption: "consoRepFioulDomestiLitre",
        coalconsumption: "consoRepCharbonAggloBriqKg",
        houilleconsumption: "consoRepHouilleKg",
        industrywoodconsumption: "consoRepBoisPlaqIndustrieKg",
        forestwoodconsumption: "consoRepBoisPlaqForestKg",
        granulewoodconsumption: "consoRepBoisGranBriqKg",
        logwoodconsumption: "consoRepBoisBuchesStere",
        heatnetworkconsumption: "consoRepReseauChaleurKWh",
        coldnetworkconsumption: "consoRepReseauFroidKWh",
    },
    com : {
        electricityconsumption: "consoComHorsIRVEKWh",
        gasconsumption: "consoComGazNatReseauxKWh",
        liquidgasconsumption: "consoComGazNatLiquefieKg",
        propanem3consumption: "consoComGazPropaneM3",
        propanekgconsumption: "consoComGazPropaneKg",
        butanem3consumption: "consoComGazButaneM3",
        butanekgconsumption: "consoComGazButaneKg",
        fuelconsumption: "consoComFioulDomestiLitre",
        coalconsumption: "consoComCharbonAggloBriqKg",
        houilleconsumption: "consoComHouilleKg",
        industrywoodconsumption: "consoComBoisPlaqIndustrieKg",
        forestwoodconsumption: "consoComBoisPlaqForestKg",
        granulewoodconsumption: "consoComBoisGranBriqKg",
        logwoodconsumption: "consoComBoisBuchesStere",
        heatnetworkconsumption: "consoComReseauChaleurKWh",
        coldnetworkconsumption: "consoComReseauFroidKWh",
    },
    chauff : {
        electricityconsumption: "chauffageConsoElecKWh",
        gasconsumption: "chauffageConsoGazNatReseauxKWh",
        liquidgasconsumption: "chauffageConsoGazNatLiquefieKg",
        propanem3consumption: "chauffageConsoGazPropaneM3",
        propanekgconsumption: "chauffageConsoGazPropaneKg",
        butanem3consumption: "chauffageConsoGazButaneM3",
        butanekgconsumption: "chauffageConsoGazButaneKg",
        fuelconsumption: "chauffageConsoFioulDomestiLitre",
        coalconsumption: "chauffageConsoCharbonAggloBriqKg",
        houilleconsumption: "chauffageConsoHouilleKg",
        industrywoodconsumption: "chauffageConsoBoisPlaqIndustrieKg",
        forestwoodconsumption: "chauffageConsoBoisPlaqForestKg",
        granulewoodconsumption: "chauffageConsoBoisGranBriqKg",
        logwoodconsumption: "chauffageConsoBoisBuchesStere",
        heatnetworkconsumption: "chauffageConsoReseauChaleurKWh",
        coldnetworkconsumption: "chauffageConsoReseauFroidKWh",
    },
    refroidissement : {
        electricityconsumption: "refroidissementConsoElecKWh",
        gasconsumption: "refroidissementConsoGazNatReseauxKWh",
        liquidgasconsumption: "refroidissementConsoGazNatLiquefieKg",
        propanem3consumption: "refroidissementConsoGazPropaneM3",
        propanekgconsumption: "refroidissementConsoGazPropaneKg",
        butanem3consumption: "refroidissementConsoGazButaneM3",
        butanekgconsumption: "refroidissementConsoGazButaneKg",
        fuelconsumption: "refroidissementConsoFioulDomestiLitre",
        coalconsumption: "refroidissementConsoCharbonAggloBriqKg",
        houilleconsumption: "refroidissementConsoHouilleKg",
        industrywoodconsumption: "refroidissementConsoBoisPlaqIndustrieKg",
        forestwoodconsumption: "refroidissementConsoBoisPlaqForestKg",
        granulewoodconsumption: "refroidissementConsoBoisGranBriqKg",
        logwoodconsumption: "refroidissementConsoBoisBuchesStere",
        heatnetworkconsumption: "refroidissementConsoReseauChaleurKWh",
        coldnetworkconsumption: "refroidissementConsoReseauFroidKWh",
    },
    froidLogist : {
        froidLogistHauteurRefroidie: "froidLogistHauteurRefroidie",
        electricityconsumption: "froidLogistConsoElecKWh",
        gasconsumption: "froidLogistConsoGazNatReseauxKWh",
        liquidgasconsumption: "froidLogistConsoGazNatLiquefieKg",
        propanem3consumption: "froidLogistConsoGazPropaneM3",
        propanekgconsumption: "froidLogistConsoGazPropaneKg",
        butanem3consumption: "froidLogistConsoGazButaneM3",
        butanekgconsumption: "froidLogistConsoGazButaneKg",
        fuelconsumption: "froidLogistConsoFioulDomestiLitre",
        coalconsumption: "froidLogistConsoCharbonAggloBriqKg",
        houilleconsumption: "froidLogistConsoHouilleKg",
        industrywoodconsumption: "froidLogistConsoBoisPlaqIndustrieKg",
        forestwoodconsumption: "froidLogistConsoBoisPlaqForestKg",
        granulewoodconsumption: "froidLogistConsoBoisGranBriqKg",
        logwoodconsumption: "froidLogistConsoBoisBuchesStere",
        heatnetworkconsumption: "froidLogistConsoReseauChaleurKWh",
        coldnetworkconsumption: "froidLogistConsoReseauFroidKWh",
    },
    froidCom : {
        electricityconsumption: "froidComConsoElecKWh",
        gasconsumption: "froidComConsoGazNatReseauxKWh",
        liquidgasconsumption: "froidComConsoGazNatLiquefieKg",
        propanem3consumption: "froidComConsoGazPropaneM3",
        propanekgconsumption: "froidComConsoGazPropaneKg",
        butanem3consumption: "froidComConsoGazButaneM3",
        butanekgconsumption: "froidComConsoGazButaneKg",
        fuelconsumption: "froidComConsoFioulDomestiLitre",
        coalconsumption: "froidComConsoCharbonAggloBriqKg",
        houilleconsumption: "froidComConsoHouilleKg",
        industrywoodconsumption: "froidComConsoBoisPlaqIndustrieKg",
        forestwoodconsumption: "froidComConsoBoisPlaqForestKg",
        granulewoodconsumption: "froidComConsoBoisGranBriqKg",
        logwoodconsumption: "froidComConsoBoisBuchesStere",
        heatnetworkconsumption: "froidComConsoReseauChaleurKWh",
        coldnetworkconsumption: "froidComConsoReseauFroidKWh",
    },
    conservationDoc : {
        electricityconsumption: "conservationDocConsoElecKWh",
        gasconsumption: "conservationDocConsoGazNatReseauxKWh",
        liquidgasconsumption: "conservationDocConsoGazNatLiquefieKg",
        propanem3consumption: "conservationDocConsoGazPropaneM3",
        propanekgconsumption: "conservationDocConsoGazPropaneKg",
        butanem3consumption: "conservationDocConsoGazButaneM3",
        butanekgconsumption: "conservationDocConsoGazButaneKg",
        fuelconsumption: "conservationDocConsoFioulDomestiLitre",
        coalconsumption: "conservationDocConsoCharbonAggloBriqKg",
        houilleconsumption: "conservationDocConsoHouilleKg",
        industrywoodconsumption: "conservationDocConsoBoisPlaqIndustrieKg",
        forestwoodconsumption: "conservationDocConsoBoisPlaqForestKg",
        granulewoodconsumption: "conservationDocConsoBoisGranBriqKg",
        logwoodconsumption: "conservationDocConsoBoisBuchesStere",
        heatnetworkconsumption: "conservationDocConsoReseauChaleurKWh",
        coldnetworkconsumption: "conservationDocConsoReseauFroidKWh",
    },
}